// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"b662880b","379":"a58b6c5c","545":"6b25f16f","787":"f2edf0ed"}[chunkId] + ".chunk.js";
};